import { PropsWithChildren } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/system';

const PopOver = ({ title, open, onClose, children, showCloseIcon = true }: PropsWithChildren<PopOverBaseProps>) => (
    <Dialog open={open}
        onClose={onClose}
        PaperProps={{ sx: { overflow: 'visible', minWidth: '340px' } }}
    >
        <DialogTitle>
            {showCloseIcon &&
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}>
                    <CloseIcon />
                </IconButton>
            }
        </DialogTitle>
        <Typography gutterBottom
            component='div' sx={{ width: '70%', marginLeft: '15%' }} >
            <Box sx={{ textAlign: 'center', fontWeight: 'bold', paddingTop: '1rem' }}>
                {title}
            </Box>
        </Typography>
        {children}
    </Dialog>
);

export type PopOverBaseProps = {
    title: string;
    open: boolean;
    onClose?: () => void;
    showCloseIcon?: boolean;
};

export { PopOver };
